import { render } from "./PerformanceForm.vue?vue&type=template&id=7cd4b4be&scoped=true"
import script from "./PerformanceForm.vue?vue&type=script&lang=js"
export * from "./PerformanceForm.vue?vue&type=script&lang=js"

import "./PerformanceForm.vue?vue&type=style&index=0&id=7cd4b4be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd4b4be"]])

export default __exports__